import 'react-app-polyfill/ie9';
import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store/index";
import App from "./components/App";
import { BrowserRouter as Router } from "react-router-dom";

const rootElement = document.getElementById("root");
const app = (
  <Provider store={store}>
    <Router basename="/">
      <App />
    </Router>
  </Provider>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  const root = createRoot(rootElement);
  root.render(app);
}